export default "__VITE_ASSET__BufIAN5b__"